import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";

export default function AccessRestricted() {
  const navigate = useNavigate();

  return (
    <Result
      status="403"
      title="Access restricted"
      subTitle="Your role does not include access to this page. If you need access, contact your administrator."
      extra={
        <Button type="primary" onClick={() => navigate("/watchtower/dashboard")}>
          Go to Dashboard
        </Button>
      }
    />
  );
}
